import React from 'react';
import PropTypes from 'prop-types';

import { Image, Letter } from './Styles';

// const propTypes = {
//   className: PropTypes.string,
//   avatarUrl: PropTypes.string,
//   name: PropTypes.string,
//   size: PropTypes.number,
// };

type PropT ={
  className: string,
  avatarUrl: string,
  name: string,
  size: number
}

const defaultProps = {
  className: undefined,
  avatarUrl: null,
  name: '',
  size: 32,
};

const Avatar = ({ className , avatarUrl , name, size, ...otherProps }: PropT) => {
  const sharedProps = {
    className,
    size,
    'data-testid': name ? `avatar:${name}` : 'avatar',
    ...otherProps,
  };

  if (avatarUrl) {
    return <Image avatarUrl={avatarUrl} {...sharedProps} />;
  }

  return (
    <Letter color={getColorFromName(name)} {...sharedProps}>
      <span>{name.charAt(0)}</span>
    </Letter>
  );
};

const colors = [
  '#DA7657',
  '#6ADA57',
  '#5784DA',
  '#AA57DA',
  '#DA5757',
  '#DA5792',
  '#57DACA',
  '#57A5DA',
];

const getColorFromName = (name : string) => colors[name.toLocaleLowerCase().charCodeAt(0) % colors.length];

// Avatar.propTypes = propTypes;
Avatar.defaultProps = defaultProps;

export default Avatar;
